module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookie-bar"
  }, [_c('cookie-law', {
    attrs: {
      "theme": "cookie-bar",
      "buttonText": "CLOSE AND CONTINUE",
      "buttonClass": "btn_orange"
    }
  }, [_c('div', {
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("\n      As you might imagine, this site uses cookies. If you continue to use this site, it means you’re ok with that. If you’d like to learn more about our cookie policy (and we know you can’t wait to do that), "), _c('a', {
    attrs: {
      "href": "/privacy",
      "title": "Privacy"
    }
  }, [_vm._v("click here.")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1a3ac68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookie-bar.vue
// module id = 1551
// module chunks = 0